import landlord from './landlord';

export default {
  namespaced: true,
  modules: {
    landlord,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/landlords/index.js